import React from 'react'
import styles from './Link.module.css'
import {
  open_link
} from '../../../Functions/Functions'
import {
  variables
} from '../../../Variables/Variables'

const ML = () => (
  <span
    className={styles.link}
    onClick={() => open_link(variables.url.server + variables.path.pdf + 'mentions_legales.pdf')}
  >
    Mentions légales
  </span>
)

export default ML
